import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class ShivaPrivateInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(environment.apiUrl) && !request.url.includes(environment.publicApiUrl)) {
      return next.handle(
        request.clone({
          headers: request.headers.set('Authorization', `Bearer ${this.authService.getAuthToken()}`),
        }),
      );
    }
    return next.handle(request);
  }
}
